export const initialState = {
  registration: null,
  referAFriend: null,
  rewardsCarousel: null,
  offers: {}
};
